import { render, staticRenderFns } from "./OrganizationAssetApplication.vue?vue&type=template&id=505a8f00&scoped=true"
import script from "./OrganizationAssetApplication.vue?vue&type=script&lang=js"
export * from "./OrganizationAssetApplication.vue?vue&type=script&lang=js"
import style0 from "./OrganizationAssetApplication.vue?vue&type=style&index=0&id=505a8f00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505a8f00",
  null
  
)

export default component.exports